import type { FlowIdentifier } from '@okta/okta-auth-js/types/lib/idx/types/FlowIdentifier'
import { LOCALES } from '@ua-okta-ui/types/constants'
import { Flows, Hints } from '@ua-okta-ui/types/enum'
import { Locale } from '@ua-okta-ui/types'

const currentScript = document.currentScript

export function getFlow(): FlowIdentifier {
	const isFlow = (flow: string | undefined): flow is FlowIdentifier =>
		!!flow && Object.values<string>(Flows).includes(flow)

	const params = new URLSearchParams(window.location.search)
	const flowParam = globalThis.uaOkta?.previewContext?.flow ?? params.get('flow') ?? undefined
	return isFlow(flowParam) ? flowParam : Flows.LOGIN
}

export function getHint(): Hints | undefined {
	const isHint = (hint: string | undefined): hint is Hints => !!hint && Object.values<string>(Hints).includes(hint)

	const params = new URLSearchParams(window.location.search)
	const hintParam = globalThis.uaOkta?.previewContext?.hint ?? params.get('hint') ?? undefined
	return isHint(hintParam) ? hintParam : undefined
}

export function getLocale(): Locale | undefined {
	const isLocale = (maybeLocale?: string): maybeLocale is Locale =>
		!!maybeLocale && LOCALES.includes(<Locale>maybeLocale)
	const params = new URLSearchParams(window.location.search)
	const localeParam = globalThis.uaOkta?.previewContext?.language ?? params.get('locale') ?? undefined
	const locale = localeParam?.replace('_', '-').toLocaleLowerCase()
	return isLocale(locale) ? locale : undefined
}

export function getStaticRootUrl() {
	if (currentScript && 'src' in currentScript) {
		return currentScript.src.split('scripts')[0]
	}
	return '/'
}
